export const TransactionIcon = (
  <svg
    width="42"
    height="42"
    viewBox="0 0 42 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="42" height="42" rx="12" fill="#20BC40" />
    <path
      d="M29.25 18.25C30.0094 18.25 30.625 17.6344 30.625 16.875C30.625 16.1156 30.0094 15.5 29.25 15.5C28.4906 15.5 27.875 16.1156 27.875 16.875C27.875 17.6344 28.4906 18.25 29.25 18.25Z"
      fill="white"
      stroke="white"
      strokeWidth="0.5"
    />
    <path
      d="M22.375 29.9375H17.5625V28.5625H22.375C25.7871 28.5625 28.5625 25.7871 28.5625 22.375V19.625H29.9375V22.375C29.9375 26.5447 26.5447 29.9375 22.375 29.9375Z"
      fill="white"
      stroke="white"
      strokeWidth="0.5"
    />
    <path
      d="M21 24.4375C19.1046 24.4375 17.5625 22.8954 17.5625 21C17.5625 19.1046 19.1046 17.5625 21 17.5625C22.8954 17.5625 24.4375 19.1046 24.4375 21C24.4375 22.8954 22.8954 24.4375 21 24.4375ZM21 18.9375C19.8629 18.9375 18.9375 19.8629 18.9375 21C18.9375 22.1371 19.8629 23.0625 21 23.0625C22.1371 23.0625 23.0625 22.1371 23.0625 21C23.0625 19.8629 22.1371 18.9375 21 18.9375Z"
      fill="white"
      stroke="white"
      strokeWidth="0.5"
    />
    <path
      d="M12.75 26.5C13.5094 26.5 14.125 25.8844 14.125 25.125C14.125 24.3656 13.5094 23.75 12.75 23.75C11.9906 23.75 11.375 24.3656 11.375 25.125C11.375 25.8844 11.9906 26.5 12.75 26.5Z"
      fill="white"
      stroke="white"
      strokeWidth="0.5"
    />
    <path
      d="M13.4375 22.375H12.0625V19.625C12.0625 15.4553 15.4553 12.0625 19.625 12.0625H24.4375V13.4375H19.625C16.2129 13.4375 13.4375 16.2129 13.4375 19.625V22.375Z"
      fill="white"
      stroke="white"
      strokeWidth="0.5"
    />
  </svg>
);

export const OrganizationIcon = (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="40" height="40" rx="12" fill="#1BC6F2" />
    <path
      d="M10.667 20C10.6662 20.8266 10.9725 21.6241 11.5266 22.2376C12.0807 22.851 12.8429 23.2367 13.6654 23.3198C14.4878 23.4029 15.3118 23.1774 15.9773 22.6871C16.6429 22.1969 17.1025 21.4768 17.267 20.6667H18.667V23.5107C18.667 24.5173 19.483 25.3333 20.4897 25.3333H22.7337C22.8989 26.1427 23.3587 26.8619 24.0241 27.3515C24.6894 27.841 25.5128 28.0661 26.3347 27.9831C27.1566 27.9001 27.9183 27.5149 28.4723 26.9021C29.0263 26.2893 29.333 25.4927 29.333 24.6667C29.333 23.8406 29.0263 23.044 28.4723 22.4312C27.9183 21.8185 27.1566 21.4332 26.3347 21.3502C25.5128 21.2672 24.6894 21.4923 24.0241 21.9819C23.3587 22.4714 22.8989 23.1906 22.7337 24H20.4897C20.4254 24 20.3618 23.9873 20.3024 23.9627C20.243 23.9382 20.1891 23.9021 20.1437 23.8567C20.0982 23.8112 20.0622 23.7573 20.0376 23.6979C20.013 23.6386 20.0003 23.5749 20.0003 23.5107V16.488C20.0003 16.2187 20.219 16 20.4897 16H22.7337C22.8989 16.8094 23.3587 17.5286 24.0241 18.0181C24.6894 18.5077 25.5128 18.7328 26.3347 18.6498C27.1566 18.5668 27.9183 18.1815 28.4723 17.5688C29.0263 16.956 29.333 16.1594 29.333 15.3333C29.333 14.5073 29.0263 13.7107 28.4723 13.0979C27.9183 12.4851 27.1566 12.0999 26.3347 12.0169C25.5128 11.9339 24.6894 12.159 24.0241 12.6485C23.3587 13.1381 22.8989 13.8573 22.7337 14.6667H20.4897C19.483 14.6667 18.667 15.4827 18.667 16.488V19.3347H17.267C17.1025 18.5247 16.643 17.8047 15.9776 17.3144C15.3122 16.8241 14.4884 16.5986 13.666 16.6815C12.8437 16.7644 12.0814 17.1498 11.5273 17.763C10.9731 18.3763 10.6665 19.1735 10.667 20ZM14.0003 22C13.4699 22 12.9612 21.7893 12.5861 21.4142C12.2111 21.0391 12.0003 20.5304 12.0003 20C12.0003 19.4696 12.2111 18.9609 12.5861 18.5858C12.9612 18.2107 13.4699 18 14.0003 18C14.5308 18 15.0395 18.2107 15.4146 18.5858C15.7896 18.9609 16.0003 19.4696 16.0003 20C16.0003 20.5304 15.7896 21.0391 15.4146 21.4142C15.0395 21.7893 14.5308 22 14.0003 22ZM26.0003 26.6667C25.4699 26.6667 24.9612 26.4559 24.5861 26.0809C24.2111 25.7058 24.0003 25.1971 24.0003 24.6667C24.0003 24.1362 24.2111 23.6275 24.5861 23.2524C24.9612 22.8774 25.4699 22.6667 26.0003 22.6667C26.5308 22.6667 27.0395 22.8774 27.4146 23.2524C27.7896 23.6275 28.0003 24.1362 28.0003 24.6667C28.0003 25.1971 27.7896 25.7058 27.4146 26.0809C27.0395 26.4559 26.5308 26.6667 26.0003 26.6667ZM24.0003 15.3333C24.0003 15.0707 24.0521 14.8106 24.1526 14.568C24.2531 14.3253 24.4004 14.1048 24.5861 13.9191C24.7718 13.7334 24.9923 13.5861 25.235 13.4856C25.4776 13.3851 25.7377 13.3333 26.0003 13.3333C26.263 13.3333 26.5231 13.3851 26.7657 13.4856C27.0084 13.5861 27.2288 13.7334 27.4146 13.9191C27.6003 14.1048 27.7476 14.3253 27.8481 14.568C27.9486 14.8106 28.0003 15.0707 28.0003 15.3333C28.0003 15.8638 27.7896 16.3725 27.4146 16.7476C27.0395 17.1226 26.5308 17.3333 26.0003 17.3333C25.4699 17.3333 24.9612 17.1226 24.5861 16.7476C24.2111 16.3725 24.0003 15.8638 24.0003 15.3333Z"
      fill="white"
      stroke="white"
      strokeWidth="0.4"
    />
  </svg>
);

export const TipperIcon = (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="40" height="40" rx="12" fill="#265FEA" />
    <g clipPath="url(#clip0_4070_702)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.1483 22.2267C23.8125 21.4117 21.9967 20.8334 20 20.8334C18.0042 20.8334 16.1875 21.4125 14.8517 22.2259C14.1842 22.6342 13.615 23.1134 13.2033 23.6342C12.7983 24.1475 12.5 24.7609 12.5 25.4167C12.5 26.1209 12.8417 26.675 13.3358 27.0717C13.8025 27.4467 14.4183 27.695 15.0725 27.8684C16.3875 28.2167 18.1425 28.3334 20 28.3334C21.8575 28.3334 23.6125 28.2159 24.9275 27.8684C25.5817 27.695 26.1975 27.4467 26.6642 27.0717C27.1575 26.6759 27.5 26.1209 27.5 25.4167C27.5 24.7609 27.2017 24.1475 26.7967 23.635C26.385 23.1134 25.815 22.6334 25.1483 22.2267ZM15.72 23.6492C16.7975 22.9917 18.3142 22.5 20 22.5C21.6858 22.5 23.2025 22.9909 24.28 23.6492C24.8192 23.9775 25.2258 24.3342 25.4892 24.6675C25.7583 25.0092 25.8333 25.2667 25.8333 25.4167C25.8333 25.5184 25.8025 25.6259 25.6208 25.7717C25.4133 25.9384 25.0525 26.1109 24.5 26.2567C23.4025 26.5475 21.825 26.6667 20 26.6667C18.1758 26.6667 16.5975 26.5484 15.4992 26.2567C14.9475 26.1109 14.5867 25.9384 14.3792 25.7717C14.1975 25.6259 14.1667 25.5184 14.1667 25.4167C14.1667 25.2675 14.2417 25.0092 14.5117 24.6675C14.7742 24.3342 15.1808 23.9775 15.72 23.6492Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.2701 15.9826L20.5755 16.0536C21.3546 16.2459 21.8848 16.6186 21.886 17.4531C21.886 18.3572 21.2127 18.861 20.2713 18.944L20.2737 19.3251C20.2737 19.3792 20.2304 19.4225 20.1775 19.4225H19.8361C19.7831 19.4225 19.7399 19.3792 19.7399 19.3263V18.9488C18.6698 18.8706 18.1684 18.2622 18.1143 17.601C18.1095 17.5444 18.154 17.4964 18.2105 17.4964H18.766C18.8129 17.4964 18.8537 17.53 18.861 17.5757C18.9223 17.958 19.2205 18.2418 19.7519 18.3127V16.597L19.4549 16.5213C18.8261 16.371 18.2273 15.979 18.2273 15.1662C18.2273 14.2885 18.8934 13.8184 19.7447 13.7354V13.3387C19.7447 13.2858 19.788 13.2425 19.8409 13.2425H20.1787C20.2316 13.2425 20.2749 13.2858 20.2749 13.3387V13.7318C21.0985 13.8148 21.7153 14.2957 21.7886 15.0448C21.7935 15.1013 21.749 15.1506 21.6925 15.1506H21.1526C21.1045 15.1506 21.0636 15.1157 21.0576 15.0676C21.0095 14.7166 20.727 14.4304 20.2701 14.3679V15.9826ZM19.5703 15.7987C19.6268 15.8215 19.6834 15.8395 19.7507 15.8588V14.3679C19.3058 14.4244 18.9752 14.6733 18.9752 15.1097C18.9752 15.4151 19.1639 15.652 19.5703 15.7987ZM20.2701 16.7088V18.3163C20.7823 18.2707 21.1358 17.9881 21.1358 17.518C21.1358 17.1489 20.9446 16.9084 20.3759 16.7353C20.341 16.7281 20.3074 16.7196 20.2701 16.7088Z"
        fill="white"
        stroke="white"
        strokeWidth="0.4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.855 16.3325C14.855 13.4913 17.1588 11.1875 20 11.1875C22.8412 11.1875 25.145 13.4913 25.145 16.3325C25.145 19.1737 22.8412 21.4775 20 21.4775C17.1588 21.4775 14.855 19.1737 14.855 16.3325ZM15.7278 16.3325C15.7278 18.6914 17.6411 20.6047 20 20.6047C22.3589 20.6047 24.2722 18.6914 24.2722 16.3325C24.2722 13.9736 22.3589 12.0603 20 12.0603C17.6411 12.0603 15.7278 13.9736 15.7278 16.3325Z"
        fill="white"
        stroke="white"
        strokeWidth="0.5"
      />
    </g>
    <defs>
      <clipPath id="clip0_4070_702">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(10 10)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const ServiceScoreIcon = (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="40" height="40" rx="12" fill="#265FEA" />
    <path
      d="M20 11.5L22.4721 17.5279L29 18.1459L24.1 22.4721L25.9443 28.8541L20 25.4L14.0557 28.8541L15.9 22.4721L11 18.1459L17.5279 17.5279L20 11.5Z"
      fill="white"
    />
  </svg>
);

export const TipNumberIcon = (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="40" height="40" rx="12" fill="#FF665D" />
    <g clipPath="url(#clip0_4152_2564)">
      <path
        d="M20.675 18.875C20.225 18.7625 19.775 18.5375 19.4375 18.2C19.1 18.0875 18.9875 17.75 18.9875 17.525C18.9875 17.3 19.1 16.9625 19.325 16.85C19.6625 16.625 20 16.4 20.3375 16.5125C21.0125 16.5125 21.575 16.85 21.9125 17.3L22.925 15.95C22.5875 15.6125 22.25 15.3875 21.9125 15.1625C21.575 14.9375 21.125 14.825 20.675 14.825V13.25H19.325V14.825C18.7625 14.9375 18.2 15.275 17.75 15.725C17.3 16.2875 16.9625 16.9625 17.075 17.6375C17.075 18.3125 17.3 18.9875 17.75 19.4375C18.3125 20 19.1 20.3375 19.775 20.675C20.1125 20.7875 20.5625 21.0125 20.9 21.2375C21.125 21.4625 21.2375 21.8 21.2375 22.1375C21.2375 22.475 21.125 22.8125 20.9 23.15C20.5625 23.4875 20.1125 23.6 19.775 23.6C19.325 23.6 18.7625 23.4875 18.425 23.15C18.0875 22.925 17.75 22.5875 17.525 22.25L16.4 23.4875C16.7375 23.9375 17.075 24.275 17.525 24.6125C18.0875 24.95 18.7625 25.2875 19.4375 25.2875V26.75H20.675V25.0625C21.35 24.95 21.9125 24.6125 22.3625 24.1625C22.925 23.6 23.2625 22.7 23.2625 21.9125C23.2625 21.2375 23.0375 20.45 22.475 20C21.9125 19.4375 21.35 19.1 20.675 18.875ZM20 11C15.05 11 11 15.05 11 20C11 24.95 15.05 29 20 29C24.95 29 29 24.95 29 20C29 15.05 24.95 11 20 11ZM20 27.7625C15.725 27.7625 12.2375 24.275 12.2375 20C12.2375 15.725 15.725 12.2375 20 12.2375C24.275 12.2375 27.7625 15.725 27.7625 20C27.7625 24.275 24.275 27.7625 20 27.7625Z"
        fill="white"
        stroke="white"
        strokeWidth="0.2"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_2564">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(10 10)"
        />
      </clipPath>
    </defs>
  </svg>
);
export const propertyDashIcon = (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="40" height="40" rx="12" fill="#265FEA" />
    <g clip-path="url(#clip0_4159_2665)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.8625 30.76C13.1033 30.76 12.3752 30.4584 11.8384 29.9216C11.3016 29.3848 11 28.6567 11 27.8975V18.3559C11 18.3235 11.0019 18.291 11.0048 18.2605H11C11 17.71 11.2185 17.1823 11.6068 16.7949L17.5646 10.8381C18.1014 10.3015 18.8294 10 19.5884 10C20.3474 10 21.0754 10.3015 21.6122 10.8381L27.569 16.7949C27.9573 17.1833 28.1758 17.7109 28.1758 18.2596H28.1711C28.1739 18.291 28.1758 18.3235 28.1758 18.355V27.8966C28.1758 28.6557 27.8743 29.3838 27.3374 29.9206C26.8006 30.4575 26.0725 30.759 25.3134 30.759L13.8625 30.76ZM20.262 12.1873L26.2666 18.1918V27.8985C26.2666 28.1515 26.166 28.3942 25.9871 28.5732C25.8082 28.7521 25.5655 28.8526 25.3124 28.8526H22.4499V24.0818C22.4499 23.3227 22.1483 22.5946 21.6115 22.0578C21.0747 21.5209 20.3466 21.2194 19.5874 21.2194C18.8283 21.2194 18.1002 21.5209 17.5634 22.0578C17.0265 22.5946 16.725 23.3227 16.725 24.0818V28.8526H13.8625C13.6094 28.8526 13.3667 28.7521 13.1878 28.5732C13.0088 28.3942 12.9083 28.1515 12.9083 27.8985V18.1918L18.9128 12.1873C19.0918 12.0084 19.3344 11.9079 19.5874 11.9079C19.8404 11.9079 20.0831 12.0084 20.262 12.1873Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_4159_2665">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(10 10)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const QrIcon = (
  <svg
    width="42"
    height="42"
    viewBox="0 0 42 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="42" height="42" rx="12" fill="#FF665D" />
    <path
      d="M14.8125 13.6667C14.18 13.6667 13.6667 14.18 13.6667 14.8125V17.3333C13.6667 17.5764 13.5701 17.8096 13.3982 17.9815C13.2263 18.1534 12.9931 18.25 12.75 18.25C12.5069 18.25 12.2737 18.1534 12.1018 17.9815C11.9299 17.8096 11.8333 17.5764 11.8333 17.3333V14.8125C11.8333 14.0224 12.1472 13.2646 12.7059 12.7059C13.2646 12.1472 14.0224 11.8333 14.8125 11.8333H17.3333C17.5764 11.8333 17.8096 11.9299 17.9815 12.1018C18.1534 12.2737 18.25 12.5069 18.25 12.75C18.25 12.9931 18.1534 13.2263 17.9815 13.3982C17.8096 13.5701 17.5764 13.6667 17.3333 13.6667H14.8125ZM14.8125 28.3333C14.18 28.3333 13.6667 27.82 13.6667 27.1875V24.6667C13.6667 24.4236 13.5701 24.1904 13.3982 24.0185C13.2263 23.8466 12.9931 23.75 12.75 23.75C12.5069 23.75 12.2737 23.8466 12.1018 24.0185C11.9299 24.1904 11.8333 24.4236 11.8333 24.6667V27.1875C11.8333 27.5787 11.9104 27.9661 12.0601 28.3276C12.2098 28.689 12.4293 29.0174 12.7059 29.2941C12.9825 29.5707 13.311 29.7902 13.6724 29.9399C14.0339 30.0896 14.4213 30.1667 14.8125 30.1667H17.3333C17.5764 30.1667 17.8096 30.0701 17.9815 29.8982C18.1534 29.7263 18.25 29.4931 18.25 29.25C18.25 29.0069 18.1534 28.7737 17.9815 28.6018C17.8096 28.4299 17.5764 28.3333 17.3333 28.3333H14.8125ZM28.3333 14.8125C28.3333 14.18 27.82 13.6667 27.1875 13.6667H24.6667C24.4235 13.6667 24.1904 13.5701 24.0185 13.3982C23.8466 13.2263 23.75 12.9931 23.75 12.75C23.75 12.5069 23.8466 12.2737 24.0185 12.1018C24.1904 11.9299 24.4235 11.8333 24.6667 11.8333H27.1875C27.5787 11.8333 27.9661 11.9104 28.3276 12.0601C28.689 12.2098 29.0174 12.4293 29.2941 12.7059C29.5707 12.9826 29.7902 13.311 29.9399 13.6724C30.0896 14.0339 30.1667 14.4213 30.1667 14.8125V17.3333C30.1667 17.5764 30.0701 17.8096 29.8982 17.9815C29.7263 18.1534 29.4931 18.25 29.25 18.25C29.0069 18.25 28.7737 18.1534 28.6018 17.9815C28.4299 17.8096 28.3333 17.5764 28.3333 17.3333V14.8125ZM27.1875 28.3333C27.82 28.3333 28.3333 27.82 28.3333 27.1875V24.6667C28.3333 24.4236 28.4299 24.1904 28.6018 24.0185C28.7737 23.8466 29.0069 23.75 29.25 23.75C29.4931 23.75 29.7263 23.8466 29.8982 24.0185C30.0701 24.1904 30.1667 24.4236 30.1667 24.6667V27.1875C30.1667 27.5787 30.0896 27.9661 29.9399 28.3276C29.7902 28.689 29.5707 29.0174 29.2941 29.2941C29.0174 29.5707 28.689 29.7902 28.3276 29.9399C27.9661 30.0896 27.5787 30.1667 27.1875 30.1667H24.6667C24.4235 30.1667 24.1904 30.0701 24.0185 29.8982C23.8466 29.7263 23.75 29.4931 23.75 29.25C23.75 29.0069 23.8466 28.7737 24.0185 28.6018C24.1904 28.4299 24.4235 28.3333 24.6667 28.3333H27.1875ZM16.4167 16.4167H19.1667V19.1667H16.4167V16.4167ZM22.8333 19.1667H19.1667V22.8333H16.4167V25.5833H19.1667V22.8333H22.8333V25.5833H25.5833V22.8333H22.8333V19.1667ZM22.8333 19.1667V16.4167H25.5833V19.1667H22.8333Z"
      fill="white"
    />
    <path
      d="M16.4167 16.4167H19.1667V19.1667H16.4167V16.4167ZM22.8333 19.1667H19.1667V22.8333H16.4167V25.5833H19.1667V22.8333H22.8333V25.5833H25.5833V22.8333H22.8333V19.1667ZM22.8333 19.1667V16.4167H25.5833V19.1667H22.8333Z"
      fill="white"
    />
  </svg>
);
export const TipAmountIcon = (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="40" height="40" rx="12" fill="#8F32EA" />
    <path
      d="M20 28.285C24.4612 28.285 27.6477 26.7071 27.6477 23.1942C27.6477 19.3767 25.7358 16.8313 21.9119 14.922L23.416 12.9871C23.4926 12.8602 23.5342 12.7152 23.5365 12.567C23.5389 12.4188 23.5019 12.2726 23.4294 12.1433C23.3568 12.014 23.2513 11.9063 23.1236 11.831C22.9958 11.7558 22.8504 11.7158 22.7022 11.715H17.2978C17.1499 11.7166 17.005 11.7571 16.8777 11.8325C16.7505 11.9079 16.6453 12.0156 16.5729 12.1446C16.5005 12.2736 16.4635 12.4194 16.4654 12.5673C16.4674 12.7152 16.5083 12.86 16.584 12.9871L18.0881 14.9347C14.2642 16.8568 12.3523 19.4022 12.3523 23.2197C12.3523 26.7071 15.5389 28.285 20 28.285Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.7628 19.7528C21.6678 19.4832 21.4915 19.2498 21.2581 19.0847C21.0248 18.9196 20.746 18.8311 20.4602 18.8312H19.392C19.0877 18.8306 18.7939 18.9426 18.5672 19.1457C18.3405 19.3488 18.197 19.6285 18.1642 19.9311C18.1314 20.2337 18.2118 20.5377 18.3898 20.7846C18.5677 21.0314 18.8308 21.2037 19.1282 21.2683L20.7559 21.6252C21.0875 21.6991 21.3803 21.8927 21.5782 22.169C21.7762 22.4452 21.8654 22.7847 21.8288 23.1225C21.7922 23.4603 21.6324 23.7728 21.3799 24.0003C21.1274 24.2277 20.8 24.3542 20.4602 24.3554H19.5412C18.9395 24.3554 18.4284 23.9705 18.2385 23.4351M20 18.8312V17.4508M20 25.7358V24.3554"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const TipRevenueIcon = (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="40" height="40" rx="12" fill="#282F40" />
    <g clipPath="url(#clip0_4070_718)">
      <path
        d="M28.05 17.8434C29.24 22.2884 26.6025 26.8584 22.1567 28.0492C18.325 29.0759 14.4033 27.2575 12.6292 23.8909C12.5262 23.6953 12.5051 23.4668 12.5706 23.2556C12.6361 23.0445 12.7827 22.868 12.9783 22.765C13.1739 22.662 13.4024 22.641 13.6136 22.7064C13.8247 22.7719 14.0012 22.9186 14.1042 23.1142C14.8183 24.4663 15.9755 25.5318 17.3818 26.1321C18.7881 26.7324 20.358 26.8311 21.8284 26.4115C23.2987 25.992 24.5802 25.0798 25.458 23.8277C26.3357 22.5757 26.7564 21.06 26.6495 19.5346C26.5426 18.0093 25.9146 16.5671 24.8708 15.4497C23.827 14.3324 22.4308 13.6078 20.9162 13.3975C19.4017 13.1871 17.8609 13.5038 16.5521 14.2944C15.2433 15.0851 14.246 16.3016 13.7275 17.74L14.6083 17.5442C15.5967 17.3234 16.16 18.6325 15.32 19.1984L13.0925 20.7C12.4942 21.1025 11.6592 20.6867 11.665 19.935C11.68 18.1118 12.2924 16.3437 13.4083 14.9018C14.5242 13.4598 16.0821 12.4235 17.8433 11.9517C22.2883 10.7584 26.8583 13.3967 28.0492 17.8417M20 15C20.221 15 20.433 15.0878 20.5893 15.2441C20.7455 15.4004 20.8333 15.6123 20.8333 15.8334V16.6667H22.5C22.721 16.6667 22.933 16.7545 23.0893 16.9108C23.2455 17.0671 23.3333 17.279 23.3333 17.5C23.3333 17.721 23.2455 17.933 23.0893 18.0893C22.933 18.2456 22.721 18.3334 22.5 18.3334H18.3333C18.2228 18.3334 18.1169 18.3773 18.0387 18.4554C17.9606 18.5335 17.9167 18.6395 17.9167 18.75C17.9167 18.8605 17.9606 18.9665 18.0387 19.0447C18.1169 19.1228 18.2228 19.1667 18.3333 19.1667H21.6667C22.2192 19.1667 22.7491 19.3862 23.1398 19.7769C23.5305 20.1676 23.75 20.6975 23.75 21.25C23.75 21.8026 23.5305 22.3325 23.1398 22.7232C22.7491 23.1139 22.2192 23.3334 21.6667 23.3334H20.8333V24.1667C20.8333 24.3877 20.7455 24.5997 20.5893 24.756C20.433 24.9122 20.221 25 20 25C19.779 25 19.567 24.9122 19.4108 24.756C19.2545 24.5997 19.1667 24.3877 19.1667 24.1667V23.3334H17.5C17.279 23.3334 17.067 23.2456 16.9108 23.0893C16.7545 22.933 16.6667 22.721 16.6667 22.5C16.6667 22.279 16.7545 22.0671 16.9108 21.9108C17.067 21.7545 17.279 21.6667 17.5 21.6667H21.6667C21.7772 21.6667 21.8832 21.6228 21.9613 21.5447C22.0394 21.4665 22.0833 21.3605 22.0833 21.25C22.0833 21.1395 22.0394 21.0335 21.9613 20.9554C21.8832 20.8773 21.7772 20.8334 21.6667 20.8334H18.3333C17.7808 20.8334 17.2509 20.6139 16.8602 20.2232C16.4695 19.8325 16.25 19.3026 16.25 18.75C16.25 18.1975 16.4695 17.6676 16.8602 17.2769C17.2509 16.8862 17.7808 16.6667 18.3333 16.6667H19.1667V15.8334C19.1667 15.6123 19.2545 15.4004 19.4108 15.2441C19.567 15.0878 19.779 15 20 15Z"
        fill="#FD7014"
      />
    </g>
    <defs>
      <clipPath id="clip0_4070_718">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(10 10)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const AllTipRevenueIcon = (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="40" height="40" rx="12" fill="#6AC312" />
    <g clipPath="url(#clip0_4152_4091)">
      <path
        d="M28.0501 17.8434C29.2401 22.2884 26.6026 26.8584 22.1567 28.0492C18.3251 29.0759 14.4034 27.2575 12.6292 23.8909C12.5262 23.6953 12.5052 23.4668 12.5707 23.2556C12.6361 23.0445 12.7828 22.868 12.9784 22.765C13.174 22.662 13.4025 22.641 13.6136 22.7064C13.8248 22.7719 14.0012 22.9186 14.1042 23.1142C14.8183 24.4663 15.9755 25.5318 17.3818 26.1321C18.7881 26.7324 20.358 26.8311 21.8284 26.4115C23.2988 25.992 24.5803 25.0798 25.458 23.8277C26.3358 22.5757 26.7565 21.06 26.6496 19.5346C26.5427 18.0093 25.9147 16.5671 24.8708 15.4497C23.827 14.3324 22.4308 13.6078 20.9163 13.3975C19.4017 13.1871 17.8609 13.5038 16.5521 14.2944C15.2433 15.0851 14.2461 16.3016 13.7276 17.74L14.6084 17.5442C15.5967 17.3234 16.1601 18.6325 15.3201 19.1984L13.0926 20.7C12.4942 21.1025 11.6592 20.6867 11.6651 19.935C11.6801 18.1118 12.2924 16.3437 13.4084 14.9018C14.5243 13.4598 16.0822 12.4235 17.8434 11.9517C22.2884 10.7584 26.8584 13.3967 28.0492 17.8417M20.0001 15C20.2211 15 20.433 15.0878 20.5893 15.2441C20.7456 15.4004 20.8334 15.6123 20.8334 15.8334V16.6667H22.5001C22.7211 16.6667 22.933 16.7545 23.0893 16.9108C23.2456 17.0671 23.3334 17.279 23.3334 17.5C23.3334 17.721 23.2456 17.933 23.0893 18.0893C22.933 18.2456 22.7211 18.3334 22.5001 18.3334H18.3334C18.2229 18.3334 18.1169 18.3773 18.0388 18.4554C17.9606 18.5335 17.9167 18.6395 17.9167 18.75C17.9167 18.8605 17.9606 18.9665 18.0388 19.0447C18.1169 19.1228 18.2229 19.1667 18.3334 19.1667H21.6667C22.2193 19.1667 22.7492 19.3862 23.1399 19.7769C23.5306 20.1676 23.7501 20.6975 23.7501 21.25C23.7501 21.8026 23.5306 22.3325 23.1399 22.7232C22.7492 23.1139 22.2193 23.3334 21.6667 23.3334H20.8334V24.1667C20.8334 24.3877 20.7456 24.5997 20.5893 24.756C20.433 24.9122 20.2211 25 20.0001 25C19.7791 25 19.5671 24.9122 19.4108 24.756C19.2545 24.5997 19.1667 24.3877 19.1667 24.1667V23.3334H17.5001C17.2791 23.3334 17.0671 23.2456 16.9108 23.0893C16.7545 22.933 16.6667 22.721 16.6667 22.5C16.6667 22.279 16.7545 22.0671 16.9108 21.9108C17.0671 21.7545 17.2791 21.6667 17.5001 21.6667H21.6667C21.7772 21.6667 21.8832 21.6228 21.9614 21.5447C22.0395 21.4665 22.0834 21.3605 22.0834 21.25C22.0834 21.1395 22.0395 21.0335 21.9614 20.9554C21.8832 20.8773 21.7772 20.8334 21.6667 20.8334H18.3334C17.7809 20.8334 17.251 20.6139 16.8603 20.2232C16.4696 19.8325 16.2501 19.3026 16.2501 18.75C16.2501 18.1975 16.4696 17.6676 16.8603 17.2769C17.251 16.8862 17.7809 16.6667 18.3334 16.6667H19.1667V15.8334C19.1667 15.6123 19.2545 15.4004 19.4108 15.2441C19.5671 15.0878 19.7791 15 20.0001 15Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_4091">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(10 10)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const refreshList = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.666656 13.3334V9.33337H4.66666"
      stroke="#05111C"
      stroke-width="1.33333"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15.3333 2.66663V6.66663H11.3333"
      stroke="#05111C"
      stroke-width="1.33333"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M2.33999 6.00001C2.6781 5.04453 3.25275 4.19028 4.0103 3.51696C4.76786 2.84363 5.68363 2.37319 6.67218 2.14952C7.66073 1.92584 8.68983 1.95624 9.66345 2.23786C10.6371 2.51948 11.5235 3.04315 12.24 3.76001L15.3333 6.66668M0.666656 9.33334L3.75999 12.24C4.47649 12.9569 5.36291 13.4805 6.33653 13.7622C7.31015 14.0438 8.33925 14.0742 9.3278 13.8505C10.3163 13.6268 11.2321 13.1564 11.9897 12.4831C12.7472 11.8097 13.3219 10.9555 13.66 10"
      stroke="#05111C"
      stroke-width="1.33333"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
